export function resolveTravelTerms(pkg = {}, rider = {}) {
  pkg = pkg || {};
  rider = rider || {};
  const packageDefinesTerms = Boolean(pkg.travel_terms_defined || pkg.travel_charge_model);
  const travelChargeModel = packageDefinesTerms ? pkg.travel_charge_model : rider.travel_charge_model;
  const travelRequired = packageDefinesTerms
    ? Boolean(pkg.travel_required)
    : Boolean(pkg.travel_required || rider.travel_modes?.length || rider.flight_class || rider.train_class);
  const accommodationRequired = packageDefinesTerms
    ? Boolean(pkg.accommodation_required)
    : Boolean(pkg.accommodation_required || (rider.hotel_required && rider.hotel_required !== "No") || rider.hotel_category);
  const localTransportRequired = packageDefinesTerms
    ? Boolean(pkg.local_transport_required)
    : Boolean(pkg.local_transport_required || rider.local_transport);
  const mealsRequired = packageDefinesTerms
    ? Boolean(pkg.meals_required)
    : Boolean(pkg.meals_required || rider.food_preference || rider.hospitality_needs?.length);
  const directTravelCost = travelChargeModel === "Included in package"
    ? false
    : Boolean(travelChargeModel || travelRequired || !packageDefinesTerms);

  return {
    packageDefinesTerms,
    travelChargeModel,
    travelRequired,
    accommodationRequired,
    localTransportRequired,
    mealsRequired,
    directTravelCost,
    requiresAcknowledgement: directTravelCost || accommodationRequired || localTransportRequired || mealsRequired,
  };
}

export function travelCostDisclosure(pkg = {}, rider = {}) {
  pkg = pkg || {};
  rider = rider || {};
  const terms = resolveTravelTerms(pkg, rider);
  const model = terms.travelChargeModel;
  const directItems = [];

  if (model === "Included in package") {
    directItems.push("Travel is included in the package.");
  } else if (terms.directTravelCost) {
    if (model === "Customer pays actual expenses") {
      directItems.push("Actual travel expenses are paid directly to the artist.");
    } else if (model === "Flat travel fee") {
      const amount = packageOrRiderValue(pkg, rider, terms, "travel_flat_fee");
      directItems.push(amount == null || amount === ""
        ? "A flat travel fee applies; confirm the amount directly with the artist."
        : `A flat travel fee of ₹${Number(amount).toLocaleString("en-IN")} is paid directly to the artist.`);
    } else if (model === "Free within certain distance") {
      const distance = packageOrRiderValue(pkg, rider, terms, "travel_free_distance_km") || 0;
      const perKm = packageOrRiderValue(pkg, rider, terms, "travel_per_km_fee") || 0;
      directItems.push(`Travel is free within ${distance} km, then ₹${Number(perKm).toLocaleString("en-IN")}/km, paid directly to the artist.`);
    } else {
      directItems.push("Travel is not included in the package; confirm the cost directly with the artist.");
    }
  }

  if (terms.accommodationRequired) directItems.push("Accommodation is a separate arrangement with the artist.");
  if (terms.localTransportRequired) directItems.push("Local transport is a separate arrangement with the artist.");
  if (terms.mealsRequired) directItems.push("Meals and hospitality are separate arrangements with the artist.");

  if (model === "Included in package" && !terms.requiresAcknowledgement) {
    return "Travel is included in the package; no additional travel payment is due to the artist.";
  }
  return directItems.join(" ");
}

function packageOrRiderValue(pkg, rider, terms, key) {
  return terms.packageDefinesTerms ? pkg[key] : rider[key];
}